import { ArticleEntity, ArticleCategoryEntity } from 'src/modules/articles/store/types';
import { LayoutDynamicZoneComponentProps } from 'src/modules/layout/components/dynamicZone/LayoutDynamicZone';

export enum ArticlesListingActions {
  FetchMagazineArticleBegin = 'ARTICLES/MAGAZINE_ARTICLE/FETCH/BEGIN',
  FetchMagazineArticleSuccess = 'ARTICLES/MAGAZINE_ARTICLE/FETCH/SUCCESS',
  FetchMagazineArticleError = 'ARTICLES/MAGAZINE_ARTICLE/FETCH/ERROR',
  FetchListingBegin = 'ARTICLES/LISTING/FETCH/BEGIN',
  FetchListingSuccess = 'ARTICLES/LISTING/FETCH/SUCCESS',
  FetchListingError = 'ARTICLES/LISTING/FETCH/ERROR',
  FetchCategoriesBegin = 'ARTICLES/CATEGORIES/FETCH/BEGIN',
  FetchCategoriesSuccess = 'ARTICLES/CATEGORIES/FETCH/SUCCESS',
  FetchCategoriesError = 'ARTICLES/CATEGORIES/FETCH/ERROR',
  SetCategoryFilter = 'ARTICLES/LISTING/SET_CATEGORY_FILTER',
  SeeMoreArticles = 'ARTICLES/LISTING/SEE_MORE',
}

export interface ArticlesListingStore {
  isLoading: boolean;
  isLoaded: boolean;
  error: any;
  magazineArticleError: any;
  magazineArticleisLoading: boolean;
  magazineArticleisLoaded: boolean;
  article: ArticleEntity;
  articles: ArticleEntity[];
  articlesCount: number;
  pagination: number;
  articleCategories?: ArticleCategoryEntity[];
  filter: ArticleCategoryEntity;
  dynamic_content: LayoutDynamicZoneComponentProps[];
}
